<p-dialog
    [breakpoints]="{ '960px': '75vw', '640px': '90vw' }"
    [style]="{ width: '45vw' }"
    [(visible)]="visible"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [closable]="true"
    (onHide)="fechar()"
>
    <ng-template pTemplate="header">
        <div class="flex justify-content-start">
            <span class="text-900 text-xl font-bold">
                <i class="pi pi-user mr-1"></i>
                {{ etapaAtual === 0 ? "Agendamentos do Cliente" : "Reagendamento" }}
            </span>
        </div>
    </ng-template>
    <ng-template pTemplate="content">
        <p-messages
            [(value)]="messagesDialog"
            [enableService]="false"
            [closable]="true"
        ></p-messages>
        <ng-container *ngIf="etapaAtual === 0">
            <div class="grid">
                <div class="col-12 field mb-0">
                    <label for="cliente" class="text-900 font-semibold">Cliente</label>
                    <div class="p-inputgroup">
                        <label id="cliente" class="form-control-agrupado">
                            {{ clienteSelecionado?.nome }}
                        </label>
                        <button
                            pButton
                            pRipple
                            pTooltip="Selecionar cliente"
                            type="button"
                            icon="pi pi-pencil"
                            class="p-button-success"
                            (click)="abrirSelecaoCliente()"
                        ></button>
                    </div>
                </div>
            </div>

            <ng-container *ngIf="clienteSelecionado; else semCliente">
                <div class="grid align-items-end mt-2">
                    <div class="col-12 md:col-4 field">
                        <label for="filtroDataInicio">Data início</label>
                        <p-calendar
                            inputId="filtroDataInicio"
                            dateFormat="dd/mm/yy"
                            [showIcon]="true"
                            [readonlyInput]="true"
                            [maxDate]="dataFim"
                            [(ngModel)]="dataInicio"
                            (ngModelChange)="carregarItens()"
                            appendTo="body"
                        ></p-calendar>
                    </div>

                    <div class="col-12 md:col-4 field">
                        <label for="filtroDataFim">Data fim</label>
                        <p-calendar
                            inputId="filtroDataFim"
                            dateFormat="dd/mm/yy"
                            [showIcon]="true"
                            [readonlyInput]="true"
                            [minDate]="dataInicio"
                            [(ngModel)]="dataFim"
                            (ngModelChange)="carregarItens()"
                            appendTo="body"
                        ></p-calendar>
                    </div>
                    <div class="col-12 md:col-4 field">
                        <div class="flex justify-content-end">
                            <button
                                pButton
                                pRipple
                                pTooltip="Gerar Relatório"
                                icon="pi pi-file-pdf"
                                class="p-button-primary"
                                [disabled]="!listaAgendamentos.length"
                                (click)="carregarRelatorioCliente()"
                            ></button>
                        </div>
                    </div>
                </div>

                <p-table
                    #tbServicos
                    [value]="listaAgendamentos"
                    dataKey="id"
                    [paginator]="true"
                    [rows]="5"
                    [loading]="loading"
                    [rowHover]="true"
                    [showCurrentPageReport]="true"
                    [hidden]="!clienteSelecionado"
                    responsiveLayout="scroll"
                    styleClass="p-datatable-sm"
                    currentPageReportTemplate="Mostrando {first} ao {last} de {totalRecords} registros"
                >
                    <ng-template pTemplate="header">
                        <tr>
                            <th style="width: 3rem"></th>

                            <th>
                                <div class="flex align-items-center gap-2">
                                    <span>Data</span>
                                </div>
                            </th>
                            <th>
                                <div class="flex align-items-center gap-2">
                                    <span>Profissional</span>
                                </div>
                            </th>
                            <th>
                                <div class="flex align-items-center gap-2">
                                    <span>Início</span>
                                </div>
                            </th>
                            <th>
                                <div class="flex align-items-center gap-2">
                                    <span>Status</span>
                                </div>
                            </th>
                            <th></th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-agendamento let-expanded="expanded">
                        <tr>
                            <td>
                                <button
                                    type="button"
                                    pButton
                                    pRipple
                                    [pRowToggler]="agendamento"
                                    class="p-button-text p-button-rounded p-button-plain shadow-none"
                                    [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
                                ></button>
                            </td>
                            <td style="min-width: 8rem">
                                {{ agendamento.dataAgendamento | date : "dd/MM/yyyy" }}
                            </td>
                            <td style="min-width: 10rem">{{ agendamento.nomeProfissional }}</td>
                            <td style="min-width: 10rem">
                                {{ agendamento.horaInicio.substring(0, 5) }}
                            </td>
                            <td style="min-width: 10rem">
                                <label
                                    class="status-badge-agenda"
                                    [ngStyle]="agendamento.status | agendaStatusStyle"
                                >
                                    {{ agendamento.status }}
                                </label>
                            </td>
                            <td style="text-align: center">
                                <button
                                    *ngIf="agendamento.status === 'CANCELADO'"
                                    pButton
                                    pRipple
                                    pTooltip="Desfazer cancelamento"
                                    icon="pi pi-refresh"
                                    class="p-button-info"
                                    (click)="reagendar(agendamento.id)"
                                ></button>
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="rowexpansion" let-agendamento>
                        <tr>
                            <td colspan="7">
                                <div class="p-3">
                                    <p-table
                                        [value]="agendamento.itens"
                                        dataKey="id"
                                        responsiveLayout="scroll"
                                        [(selection)]="selectedItems"
                                        selectionMode="multiple"
                                    >
                                        <ng-template pTemplate="header">
                                            <tr>
                                                <th style="width: 4rem">
                                                    <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                                                </th>
                                                <th>Serviço</th>
                                                <th>Duração</th>
                                            </tr>
                                        </ng-template>
                                        <ng-template pTemplate="body" let-item>
                                            <tr>
                                                <td>
                                                    <p-tableCheckbox
                                                        [value]="item"
                                                    ></p-tableCheckbox>
                                                </td>
                                                <td>{{ item.descricao }}</td>
                                                <td>{{ item.duracao.substring(0, 5) }}</td>
                                            </tr>
                                        </ng-template>
                                        <ng-template pTemplate="emptymessage">
                                            <tr>
                                                <td colspan="6">
                                                    There are no order for this product yet.
                                                </td>
                                            </tr>
                                        </ng-template>
                                    </p-table>
                                </div>
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage">
                        <tr>
                            <td colspan="8">Nenhum dado encontrado.</td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="loadingbody">
                        <tr>
                            <td colspan="8">Carregando dados. Por favor aguarde.</td>
                        </tr>
                    </ng-template>
                </p-table>
                <div class="flex justify-content-end mt-2" *ngIf="selectedItems.length">
                    <button
                        pButton
                        pRipple
                        label="Reagendar"
                        pTooltip="Reagendar selecionados"
                        type="button"
                        icon="pi pi-reply"
                        class="p-button-primary w-3"
                        (click)="avancarEtapa()"
                    ></button>
                </div>
            </ng-container>

            <ng-template #semCliente>
                <div class="p-3 text-center text-800">
                    Selecione um cliente para visualizar os agendamentos.
                </div>
            </ng-template>
        </ng-container>

        <ng-container *ngIf="etapaAtual === 1">
            <div class="grid">
                <div class="col-12 field">
                    <label class="text-900 font-semibold">Cliente</label>
                    <label class="form-control text-600">
                        {{ clienteSelecionado?.nome }}
                    </label>
                </div>
            </div>

            <div class="grid align-items-end mt-2">
                <div class="col-6 field">
                    <label for="novaData" class="text-900 font-semibold">Data</label>
                    <p-calendar
                        inputId="novaData"
                        placeholder="Selecione"
                        dateFormat="dd/mm/yy"
                        [showIcon]="true"
                        [readonlyInput]="true"
                        [minDate]="hoje"
                        [(ngModel)]="novaDataAgendamento"
                        (ngModelChange)="selecionarDia()"
                        appendTo="body"
                    ></p-calendar>
                </div>

                <div class="col-6 field">
                    <label for="novaHora" class="text-900 font-semibold">Hora Início</label>

                    <p-calendar
                        placeholder="Selecione"
                        inputId="calendar-timeonly"
                        [(ngModel)]="novaHoraAgendamento"
                        [timeOnly]="true"
                    ></p-calendar>
                </div>
            </div>

            <p-table
                [value]="listaItensReagendamento"
                responsiveLayout="scroll"
                styleClass="p-datatable-sm mt-3"
            >
                <ng-template pTemplate="caption">
                    <span class="text-900 font-semibold">Serviços selecionados</span>
                </ng-template>
                <ng-template pTemplate="header">
                    <tr>
                        <th>Serviço</th>
                        <th style="width: 8rem">Duração</th>
                        <th style="text-align: end">Profissional</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-item>
                    <tr>
                        <td>{{ item.descricao }}</td>
                        <td>{{ item.duracao.substring(0, 5) }}</td>
                        <td style="text-align: end">
                            <p-dropdown
                                [options]="profissionais"
                                optionLabel="nomeProfissional"
                                optionValue="id"
                                [filter]="true"
                                emptyFilterMessage="Nenhum registro"
                                placeholder="Selecione"
                                appendTo="body"
                                [(ngModel)]="item.profissionalId"
                            ></p-dropdown>
                        </td>
                    </tr>
                </ng-template>
            </p-table>

            <div class="flex justify-content-between mt-5 w-full">
                <button
                    pButton
                    pRipple
                    label="Voltar"
                    icon="pi pi-arrow-left"
                    class="p-button-primary w-3"
                    (click)="voltarEtapa()"
                ></button>
                <button
                    pButton
                    pRipple
                    label="Salvar"
                    icon="pi pi-check"
                    class="p-button-success w-3"
                    [loading]="salvando"
                    (click)="salvar()"
                ></button>
            </div>
        </ng-container>
    </ng-template>
</p-dialog>
<app-select-cliente-dialog
    [(visible)]="exibirSelecaoCliente"
    (selecionar)="selecionarCliente($event)"
></app-select-cliente-dialog>
